export type AreaPrefecture = {
  name: string;
  path: string;
  cities?: { name: string; path: string }[];
};

export type AreaSection = {
  areaName: string;
  areaPath: string;
  prefectures: AreaPrefecture[];
};

export const EMPLOYMENT_TYPE_LINKS: [string, string][] = [
  ['/new_grad', '新卒'],
  ['/mid_career', '中途・転職'],
  ['/part_time', 'アルバイト'],
  ['/internship', 'インターン'],
  ['/side_job', '副業・業務委託'],
];

export const OCCUPATION_LINKS: [string, string][] = [
  ['/management_officer', '経営/マネージャー'],
  ['/md', 'MD'],
  ['/buyer', 'バイヤー'],
  ['/production_management', '企画・生産管理・物流'],
  ['/fashion_designer', 'ファッションデザイナー'],
  ['/pattern_maker', 'パタンナー'],
  ['/marketing', '販促/マーケティング'],
  ['/vmd_store_development', 'VMD/店舗開発'],
  ['/sales', '営業'],
  ['/store_sales', '販売'],
  ['/ec', 'WEB関連/EC'],
  ['/media', '制作/メディア'],
  ['/backoffice', 'バックオフィス'],
];

export const INDUSTRY_LINKS: [string, string][] = [
  ['/companies/tag/retail', '小売・リテール'],
  ['/companies/tag/trading_company', '商社'],
  ['/companies/tag/maker', 'メーカー'],
  ['/companies/tag/oemodm', 'OEM・ODM'],
  ['/companies/tag/pr', 'PR'],
  ['/companies/tag/select', 'セレクトショップ'],
  ['/companies/tag/ec', 'EC/通販'],
  ['/companies/tag/importer', '代理店・ライセンス'],
  ['/companies/tag/distributor', '卸売'],
  ['/companies/tag/factory', '工場'],
  ['/companies/tag/itservice', 'IT・サービス開発'],
  ['/companies/tag/oldclothes', '古着・リユース・2次流通'],
  ['/companies/tag/media', 'メディア・編集'],
  ['/companies/tag/foreign_capital', '外資'],
  ['/companies/tag/btob', 'BtoB'],
];

export const AREA_SECTIONS: AreaSection[] = [
  {
    areaName: '北海道・東北',
    areaPath: '/tohoku',
    prefectures: [
      { name: '北海道', path: '/hokkaido', cities: [{ name: '札幌市', path: '/sapporo-city' }] },
      { name: '青森県', path: '/aomori' },
      { name: '岩手県', path: '/iwate' },
      { name: '宮城県', path: '/miyagi', cities: [{ name: '仙台市', path: '/sendai-city' }] },
      { name: '秋田県', path: '/akita' },
      { name: '山形県', path: '/yamagata' },
      { name: '福島県', path: '/fukushima' },
    ],
  },
  {
    areaName: '関東',
    areaPath: '/kanto',
    prefectures: [
      { name: '茨城県', path: '/ibaraki' },
      { name: '栃木県', path: '/tochigi' },
      { name: '群馬県', path: '/gunma' },
      { name: '埼玉県', path: '/saitama', cities: [{ name: 'さいたま市', path: '/saitama-city' }] },
      { name: '千葉県', path: '/chiba', cities: [{ name: '千葉市', path: '/chiba-city' }] },
      { name: '東京都', path: '/tokyo' },
      { name: '神奈川県', path: '/kanagawa', cities: [{ name: '横浜市', path: '/yokohama-city' }, { name: '川崎市', path: '/kawasaki-city' }, { name: '相模原市', path: '/sagamihara-city' }] },
    ],
  },
  {
    areaName: '北陸・甲信越',
    areaPath: '/hokuriku',
    prefectures: [
      { name: '新潟県', path: '/niigata', cities: [{ name: '新潟市', path: '/niigata-city' }] },
      { name: '富山県', path: '/toyama' },
      { name: '石川県', path: '/ishikawa' },
      { name: '福井県', path: '/fukui' },
      { name: '山梨県', path: '/yamanashi' },
      { name: '長野県', path: '/nagano' },
    ],
  },
  {
    areaName: '東海',
    areaPath: '/tokai',
    prefectures: [
      { name: '岐阜県', path: '/gifu' },
      { name: '静岡県', path: '/shizuoka', cities: [{ name: '静岡市', path: '/shizuoka-city' }, { name: '浜松市', path: '/hamamatsu-city' }] },
      { name: '愛知県', path: '/aichi', cities: [{ name: '名古屋市', path: '/nagoya-city' }] },
      { name: '三重県', path: '/mie' },
    ],
  },
  {
    areaName: '近畿',
    areaPath: '/kinki',
    prefectures: [
      { name: '滋賀県', path: '/shiga' },
      { name: '京都府', path: '/kyoto', cities: [{ name: '京都市', path: '/kyoto-city' }] },
      { name: '大阪府', path: '/osaka', cities: [{ name: '大阪市', path: '/osaka-city' }, { name: '堺市', path: '/sakai-city' }] },
      { name: '兵庫県', path: '/hyogo', cities: [{ name: '神戸市', path: '/kobe-city' }] },
      { name: '奈良県', path: '/nara' },
      { name: '和歌山県', path: '/wakayama' },
    ],
  },
  {
    areaName: '中国・四国',
    areaPath: '/chugoku',
    prefectures: [
      { name: '鳥取県', path: '/tottori' },
      { name: '島根県', path: '/shimane' },
      { name: '岡山県', path: '/okayama', cities: [{ name: '岡山市', path: '/okayama-city' }] },
      { name: '広島県', path: '/hiroshima', cities: [{ name: '広島市', path: '/hiroshima-city' }] },
      { name: '山口県', path: '/yamaguchi' },
      { name: '徳島県', path: '/tokushima' },
      { name: '香川県', path: '/kagawa' },
      { name: '愛媛県', path: '/ehime' },
      { name: '高知県', path: '/kochi' },
    ],
  },
  {
    areaName: '九州・沖縄',
    areaPath: '/kyushu',
    prefectures: [
      { name: '福岡県', path: '/fukuoka', cities: [{ name: '北九州市', path: '/kitakyushu-city' }, { name: '福岡市', path: '/fukuoka-city' }] },
      { name: '佐賀県', path: '/saga' },
      { name: '長崎県', path: '/nagasaki' },
      { name: '熊本県', path: '/kumamoto', cities: [{ name: '熊本市', path: '/kumamoto-city' }] },
      { name: '大分県', path: '/oita' },
      { name: '宮崎県', path: '/miyazaki' },
      { name: '鹿児島県', path: '/kagoshima' },
      { name: '沖縄県', path: '/okinawa' },
    ],
  },
];

export const LIST_LINKS: [string, string][] = [
  ['/search', '求人'],
  ['/brands', 'ブランド'],
  ['/events', 'イベント'],
  ['/companies', '会社'],
  ['/tvs', '動画'],
];
